var React = require("react");

var AssetDetail = require("./generic/AssetDetail.jsx");
var MasterPage = require("./generic/MasterPage.jsx");
var Model3DPreview = require("../controls/preview/Model3DPreview.jsx");
var ExportStepButton = require("../controls/buttons/infoPageButtons/ExportStepButton.jsx");
var ExportF3dButton = require("../controls/buttons/infoPageButtons/ExportF3dButton.jsx");
var ExportObjButton = require("../controls/buttons/infoPageButtons/ExportObjButton.jsx");
let PublicPrivateButton = require("../controls/buttons/infoPageButtons/PublicPrivateButton.jsx"); 
var DeleteInfoButton = require("../controls/buttons/infoPageButtons/DeleteInfoButton.jsx"); 

class Model3DDetail extends React.Component {

    constructor() {
        super()
    }

    render() {
      
        let buttons = [
            ExportStepButton,
            ExportObjButton,
            PublicPrivateButton,
            DeleteInfoButton
        ]
        
        let premiumButtons = [
            ExportF3dButton,
        ]
        
        return (
            <MasterPage
                {...this.props}
                renderPage={addedProps => 
                    <AssetDetail
                        {...addedProps}
                        {...this.props}
                        className="3dmodels"
                        urlName="3dmodels"
                        displayName="3D Model"
                        Preview={Model3DPreview}
                        premiumButtons={premiumButtons}
                        buttons={buttons}
                    /> 
                }
            />
        );
    }
}

module.exports = Model3DDetail;
